<script setup>
const props = defineProps({
  faqs: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div>
    <div class="accordion" id="faqAccordion">
      <div
        v-for="(faq, index) in faqs"
        :key="index"
        class="accordion-item"
      >
        <h2 class="accordion-header" :id="'heading' + index">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + index"
            aria-expanded="false"
            :aria-controls="'collapse' + index"
          >
            {{ faq.question }}
          </button>
        </h2>

        <div
          :id="'collapse' + index"
          class="accordion-collapse collapse"
          :aria-labelledby="'heading' + index"
          data-bs-parent="#faqAccordion"
        >
          <div class="accordion-body" v-html="faq.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.accordion-item {
  border: 1px solid #D3D3D3;
}
</style>